<div>
  <ng-container *ngFor="let option of options; index as index">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <span class="fw-bold mb-0">{{ option?.label }}</span>
        <!-- <p *ngIf="button?.button_sublabel" class="text-muted m-0">
            {{ button?.button_sublabel }}
          </p> -->
      </div>
      <div class="justify-content-end">
        <ui-switch
          color="#34c38f"
          [checked]="selected_button_value[option?.id] ? true : false"
          [disabled]="button && button?.button_disable"
          uncheckedLabel="No"
          checkedLabel="Yes"
          size="small"
          class="me-1"
          (change)="togglePermanent($event, option)"
        ></ui-switch>
      </div>
    </div>
  </ng-container>
</div>
